import { render, staticRenderFns } from "./Claim.vue?vue&type=template&id=5e37a007"
import script from "./Claim.vue?vue&type=script&lang=js"
export * from "./Claim.vue?vue&type=script&lang=js"
import style0 from "./Claim.vue?vue&type=style&index=0&id=5e37a007&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports